"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRIDGE_CONTRACT = exports.domainSeparator = exports.SignedPairAddressSchemaModel = exports.UserBridgeWithdrawableBalanceItemModel = exports.liquidityNotificationConfigModel = exports.SwapTxModel = exports.getEnv = exports.CHAIN_ID_FOR_NETWORK = exports.TOKEN_BRIDGE_DOMAIN_SALT = exports.PairedAddressType = void 0;
const mongoose_1 = require("mongoose");
const ferrum_plumbing_1 = require("ferrum-plumbing");
const ferrum_plumbing_2 = require("ferrum-plumbing");
exports.PairedAddressType = {
    Pair: [
        { name: "network1", type: "string" },
        { name: "address1", type: "address" },
        { name: "network2", type: "string" },
        { name: "address2", type: "address" },
    ],
};
exports.TOKEN_BRIDGE_DOMAIN_SALT = "0xebb7c67ee709a29f4d80f3ac6db9cd0e84fccb20437963314b825afc2463825c";
exports.CHAIN_ID_FOR_NETWORK = {
    ETHEREUM: 1,
    RINKEBY: 4,
    BSC: 56,
    BSC_TESTNET: 97,
    POLYGON: 137,
    MUMBAI_TESTNET: 80001,
};
const signatureSchema = new mongoose_1.Schema({
    creationTime: Number,
    creator: String,
    signature: String,
});
const payBySignatureDataSchema = new mongoose_1.Schema({
    token: String,
    payee: String,
    amount: String,
    toToken: String,
    sourceChainId: Number,
    swapTxId: String,
    contractName: String,
    contractVersion: String,
    contractAddress: String,
    hash: String,
    signatures: [signatureSchema],
});
///@ts-ignore
const liquidityNotificationConfigSchema = new mongoose_1.Schema({
    projectAdminEmail: String,
    currency: String,
    listenerUrl: String,
    upperthreshold: Number,
    lowerthreshold: Number,
    lastNotifiedTime: Number
});
//@ts-ignore
const userBridgeWithdrawableBalanceItemSchema = new mongoose_1.Schema({
    id: String,
    timestamp: Number,
    receiveNetwork: String,
    receiveCurrency: String,
    receiveAddress: String,
    receiveAmount: String,
    receiveTransactionId: String,
    salt: String,
    signedWithdrawHash: String,
    signedWithdrawSignature: String,
    sendNetwork: String,
    sendAddress: String,
    sendTimestamp: Number,
    sendTransactionId: String,
    sendCurrency: String,
    sendAmount: String,
    payBySig: payBySignatureDataSchema,
    used: String,
    useTransactions: [{ id: String, status: String, timestamp: Number }],
});
//@ts-ignore
const SignedPairAddressSchema = new mongoose_1.Schema({
    pair: new mongoose_1.Schema({
        network1: String,
        address1: String,
        network2: String,
        address2: String,
    }),
    signature1: String,
    signature2: String,
});
function getEnv(env) {
    const res = process.env[env];
    ferrum_plumbing_1.ValidationUtils.isTrue(!!res, `Make sure to set environment variable '${env}'`);
    return res;
}
exports.getEnv = getEnv;
const swapTxSchema = new mongoose_1.Schema({
    id: String,
    network: String,
    status: String,
    reason: String,
});
exports.SwapTxModel = (c) => c.model("swapTransactions", swapTxSchema);
exports.liquidityNotificationConfigModel = (c) => c.model("liquidityNotificationConfig", liquidityNotificationConfigSchema);
exports.UserBridgeWithdrawableBalanceItemModel = (c) => c.model("userBridgeWithdrawableBalanceItem", userBridgeWithdrawableBalanceItemSchema);
exports.SignedPairAddressSchemaModel = (c) => c.model("signedPairAddress", SignedPairAddressSchema);
function domainSeparator(network) {
    const chainId = ferrum_plumbing_2.Networks.for(network).chainId;
    return {
        chainId: chainId.toString(),
        name: "PairedUnifyreWallet",
        verifyingContract: exports.BRIDGE_CONTRACT[network],
        version: "0.1.0",
    };
}
exports.domainSeparator = domainSeparator;
exports.BRIDGE_CONTRACT = {
    ETHEREUM: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
    RINKEBY: "0x89262b7bd8244b01fbce9e1610bf1d9f5d97c877",
    BSC: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
    BSC_TESTNET: "0x89262b7bd8244b01fbce9e1610bf1d9f5d97c877",
    POLYGON: "0x8e01cc26d6dd73581347c4370573ce9e59e74802",
    MUMBAI_TESTNET: "0x89262b7bd8244b01fbce9e1610bf1d9f5d97c877",
};
//# sourceMappingURL=TokenBridgeTypes.js.map